(() => {
  const script = document.currentScript;
  const currency = script?.dataset.currency || window.Shopify?.currency?.active;

  if (currency !== 'EUR') return;

  const euroPrefix = /€\s*([0-9]+(?:[.,\s\u00a0][0-9]{3})*(?:[.,][0-9]{1,2})?)/g;
  const ignoredTags = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'SELECT', 'OPTION']);

  const formatTextNode = (node) => {
    if (!node.nodeValue?.includes('€') || ignoredTags.has(node.parentElement?.tagName)) return;
    const formattedValue = node.nodeValue.replace(euroPrefix, '$1 €');
    if (formattedValue !== node.nodeValue) node.nodeValue = formattedValue;
  };

  const formatTree = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      formatTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) formatTextNode(node);
  };

  const start = () => {
    formatTree(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') formatTextNode(mutation.target);
        mutation.addedNodes.forEach(formatTree);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
